export class PaginacaoDto<T> {
  public currentPage?: number;
  public pageCount?: number;
  public total?: number;
  public quantidadeRegistros?: number;
  public numPerPage?: number;
  public data?: Array<T> = new Array<T>();
  public ultimaPagina?: number;

  constructor(object?: any) {
    if (object) {
      this.currentPage = object.currentPage;
      this.pageCount = object.pageCount;
      this.total = object.total;
      this.quantidadeRegistros = object.quantidadeRegistros;
      this.numPerPage = object.numPerPage;
      this.data = object.data;
      this.ultimaPagina = object.ultimaPagina;
    }
  }
}
